/* Careatic — size finder (ported from SizeFinder.jsx).
   Size chips (12–30) switch the active data pane (breed/weight/classification/
   price grid). First size pre-selected. Fires select_item per pick. */
(function () {
  'use strict';
  function setup(root) {
    if (root.dataset.caBound) return;
    root.dataset.caBound = '1';
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ca-size]'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('[data-ca-pane]'));
    if (!chips.length) return;

    function pick(size) {
      chips.forEach(function (c) { c.setAttribute('data-active', c.dataset.caSize === size); });
      panes.forEach(function (p) { p.setAttribute('data-active', p.dataset.caPane === size); });
      if (window.caTrack) window.caTrack('select_item', { item_list_id: 'size_finder', item_id: 'size_' + size });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { pick(c.dataset.caSize); });
    });
    // pre-select first
    var first = chips[0].dataset.caSize;
    chips.forEach(function (c) { c.setAttribute('data-active', c.dataset.caSize === first); });
    panes.forEach(function (p) { p.setAttribute('data-active', p.dataset.caPane === first); });
  }
  function init() { document.querySelectorAll('[data-ca-finder]').forEach(setup); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
